/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompetenceIncludeFilterItems } from './competenceIncludeFilterItems';
import { CompetenceScopeFilter } from './competenceScopeFilter';


export interface CompetenceIncludeFilterInner { 
    relation?: CompetenceIncludeFilterInner.RelationEnum;
    scope?: CompetenceScopeFilter;
}
export namespace CompetenceIncludeFilterInner {
    export type RelationEnum = 'competenceType' | 'relationTypes';
    export const RelationEnum = {
        CompetenceType: 'competenceType' as RelationEnum,
        RelationTypes: 'relationTypes' as RelationEnum
    };
}


